import apiService from '../api/apiService';
import { resizeImage } from '../utils/imageUtils';
import { triggerImageDeletionFromUrl } from './imageAssetCleanup';

export const replaceAuthorAvatar = async (
  avatarFile: File,
  currentAvatarUrl: string | null | undefined
) => {
  if (currentAvatarUrl) {
    triggerImageDeletionFromUrl(
      currentAvatarUrl,
      'Could not extract old file path from author avatar URL:'
    );
  }

  const resizedAvatarFile = await resizeImage(avatarFile, 256, 256, 0.7);
  return apiService.uploadImage(resizedAvatarFile);
};

export const clearAuthorAvatar = async (
  authorId: number,
  currentAvatarUrl: string
) => {
  triggerImageDeletionFromUrl(
    currentAvatarUrl,
    'Could not extract file path from current avatar URL:'
  );

  await apiService.updateAuthor({
    id: authorId,
    avatar_url: null,
  });
};
